import { OffersPromoRepository } from "../../Repository/OffersPromoRepository";

export interface RemovePromoBarItemTableUseCase {
    invoke: (promoBarId : number) => Promise<boolean>;
  }
  
  export class RemovePromoBarItemTable implements RemovePromoBarItemTableUseCase {
    private repo: OffersPromoRepository;
    constructor(_repo: OffersPromoRepository) {
      this.repo = _repo;
    }
  
    async invoke(promoBarId : number){
       
        if(!promoBarId){
            throw new Error(
                "Ha ocurrido un error!"
              );
        }
         
        const deleted  = await this.repo.removePromoBarItemTable(promoBarId);
        return deleted;
    }
  }